// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__tONQE","rightAdornment":"Header_rightAdornment__3F8tX"};